<template>
  <div v-if="intent">
    <v-layout class="mb-3">
      <v-flex form-control :class="{ 'has-error': errors.has('intentName') }" class="pa-2">
        <input
          type="text"
          class="form-control"
          :placeholder="$t('Conversation')"
          v-model="intent.intentname"
          name="intentName"
          :data-vv-as="$t('Conversation')"
          aria-describedby="Intent Name"
          v-validate="
            'required|excluded:{default},{welcome}' + (excludedName ? ',' + excludedName : '')
          "
        />
        <span class="text-error" v-show="errors.has('intentName')">
          {{ errors.first('intentName') }}
        </span>
      </v-flex>
      <slot name="header"></slot>
    </v-layout>
    <v-divider></v-divider>
    <div class="pa-2">
      <template v-if="loadingApiList"></template>
      <template v-else>
        <h3 class="primary--text mb-2">Api Name</h3>
        <v-autocomplete
          v-model="selectedApi"
          :items="apiOptions"
          outline
          label="Api"
          @change="onChangeApi"
          hide-details
        >
        </v-autocomplete>

        <template v-if="api && !loading">
          <div v-if="api.description" class="mt-3 grey--text">
            {{ api.description }}
          </div>
          <h3 class="primary--text mt-3 mb-2">Input</h3>
          <template v-if="api.api_req_format.length > 0">
            <div class="grey--text mb-2">Set parameter</div>
            <div
              class="z-border-red mb-2"
              v-for="(req, index) in api.api_req_format"
              :key="'request_' + index + '_' + req.name"
            >
              <v-layout wrap>
                <v-flex xs5 class="form-control pa-2">{{ req.name }}</v-flex>
                <v-flex xs1 class="text-xs-center">
                  <v-icon class="mt-3">arrow_back</v-icon>
                </v-flex>
                <v-flex xs6 class="form-control pa-1">
                  <api-request-manage
                    :key="`value_${index}_${req.rand}`"
                    :data-name="req.name"
                    v-model="request"
                  ></api-request-manage>
                  <span class="caption grey--text">{{ req.possible_output }}</span>
                </v-flex>
              </v-layout>
            </div>
          </template>
          <div class="text-xs-center grey--text" v-else>No parameter</div>

          <h3 class="primary--text mt-3 mb-2">Output</h3>

          <template v-if="api.api_res_format.length > 0">
            <div class="grey--text mb-2">Save to variable</div>
            <div
              class="z-border-red mb-2"
              v-for="(res, index) in api.api_res_format"
              :key="'response_' + index"
            >
              <v-layout wrap>
                <v-flex xs5 class="form-control pa-2"
                  >{{ res.name }}
                  <div class="form-control grey--text caption" v-if="res.description">
                    {{ res.description }}
                    <!-- <textarea v-model="res.description" placeholder="Description" style="width: 100%"></textarea> -->
                  </div>
                </v-flex>
                <v-flex xs1 class="text-xs-center">
                  <v-icon class="mt-3">arrow_forward</v-icon>
                </v-flex>
                <v-flex xs6 class="pa-1">
                  <api-response-manage
                    :key="`value_${index}_${res.rand}`"
                    :data-name="res.name"
                    v-model="response"
                  ></api-response-manage>
                  <span class="caption grey--text">{{ res.possible_output }}</span>
                </v-flex>
              </v-layout>
            </div>
          </template>
          <div class="text-xs-center grey--text" v-else>No parameter</div>
        </template>
      </template>
    </div>
    <div class="text-xs-center pa-2">
      <v-btn outline color="grey" @click="onCancel">{{ $t('cancel') }}</v-btn>
      <v-btn color="primary" depressed @click="onSave">{{ $t('Save') }}</v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Multiselect from 'vue-multiselect'
import ApiRequestManage from './ApiRequestManage'
import ApiResponseManage from './ApiResponseManage'
import api from '@/api'
export default {
  props: ['value'],
  data() {
    return {
      intent: null,
      excludedName: '',
      selectedApi: null,
      api: null,
      request: [],
      response: [],
      loading: true
    }
  },
  computed: {
    ...mapGetters({
      loadingApiList: 'getLoadingApiList',
      apiList: 'getApiList'
    }),
    apiOptions() {
      var api = []
      if (!this.loadingApiList) {
        api = this.apiList.map(el => {
          return {
            text: el.api_name,
            value: el.id
          }
        })
      }
      return api
    }
  },
  components: {
    Multiselect,
    ApiRequestManage,
    ApiResponseManage
  },
  mounted() {
    var vm = this
    this.loading = true
    vm.intent = vm.value
    if (vm.intent.answer.length == 0 || vm.intent.answer[0].length == 0) {
      vm.intent.answer = [
        [
          {
            api_name: '',
            api_method: '',
            api_id: 0,
            data: null,
            req: '',
            type: 'api',
            update: ''
          }
        ]
      ]
      //   vm.$emit('input', vm.intent)
    }

    this.resetRequestAndResponse(vm.intent.answer[0][0])
    var option = vm.apiOptions.find(el => {
      return el.value == vm.intent.answer[0][0].api_id
    })
    if (option) {
      var api = vm.apiList.find(el => {
        return el.id == vm.intent.answer[0][0].api_id
      })

      if (api) {
        vm.api = JSON.parse(JSON.stringify(api))
        try {
          vm.$set(
            vm.api,
            'api_req_format',
            vm.api.api_req_format && vm.api.api_req_format != null
              ? JSON.parse(vm.api.api_req_format)
              : []
          )
        } catch (error) {
          vm.$set(vm.api, 'api_req_format', [])
        }

        try {
          vm.$set(
            vm.api,
            'api_res_format',
            vm.api.api_res_format && vm.api.api_res_format != null
              ? JSON.parse(vm.api.api_res_format)
              : []
          )
        } catch (error) {
          vm.$set(vm.api, 'api_res_format', [])
        }
      }
      vm.selectedApi = option
    }
    vm.cached_intent = JSON.stringify(vm.intent)
    this.loading = false
  },
  methods: {
    onCancel() {
      this.intent = JSON.parse(this.cached_intent)
      if (this.intent.answer[0][0].api_id == 0) {
        this.intent.answer = []
      }
      this.$emit('onCancel')
    },
    onSave() {
      var vm = this
      var data = this.intent
      var request = []
      var response = []
      request = this.request
        .map(el => {
          if (el.value && el.value != '') {
            return `${el.name}={${el.value}}`
          } else {
            return null
          }
        })
        .filter(el => {
          return el != null
        })
      response = this.response
        .map(el => {
          if (el.value && el.value != '') {
            let request = {
              variable_name: el.value,
              api_id: vm.api.id,
              api_res_name: el.name,
              description: el.description || ''
            }
            api.saveVariablePossibleOutput(request, function() {})
            return `${el.value}=${el.name}`
          } else {
            return null
          }
        })
        .filter(el => {
          return el != null
        })
      data.answer[0][0].req = request.join('&')
      data.answer[0][0].update = response.join(',')
      data.answer[0][0].data = this.api.api_data_format

      this.$emit('input', data)
      this.$emit('onSave', data)
      this.cached_intent = JSON.stringify(data)
    },
    resetRequestAndResponse(api) {
      var req = api.req != '' && api.req != null ? api.req.split('&') : []
      var request = []
      if (req.length > 0) {
        request = req.map(el => {
          var val = el.split('=')
          return {
            name: val[0],
            value: val[1].substr(1).substr(0, val[1].length - 2),
            rand: Math.random() * 10000000
          }
        })
      }
      this.request = request
      var res = api.update != '' && api.update != null ? api.update.split(',') : []
      var response = []
      if (res.length > 0) {
        response = res.map(el => {
          var val = el.split('=')
          return {
            name: val[1],
            value: val[0],
            rand: Math.random() * 10000000
          }
        })
      }
      this.response = response
    },
    async onChangeApi(type) {
      this.loading = true
      var vm = this

      var api = this.apiList.find(el => {
        return el.id == type
      })
      if (api) {
        vm.api = JSON.parse(JSON.stringify(api))
        this.$set(this.intent.answer[0], 0, {
          api_id: type,
          api_name: vm.api.api_name,
          api_method: vm.api.api_method,
          data: vm.api.api_data_format,
          req: '',
          type: 'api',
          update: ''
        })

        this.resetRequestAndResponse(vm.intent.answer[0][0])

        await this.$nextTick()
        if (vm.api) {
          var req = []
          try {
            req =
              vm.api.api_req_format && vm.api.api_req_format != null
                ? JSON.parse(vm.api.api_req_format)
                : []
          } finally {
            vm.$set(vm.api, 'api_req_format', req)
          }

          var res = []
          try {
            res =
              vm.api.api_res_format && vm.api.api_res_format != null
                ? JSON.parse(vm.api.api_res_format)
                : []
          } finally {
            vm.$set(vm.api, 'api_res_format', res)
          }
        }
        this.$forceUpdate()
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/flow/ApiManage.vue